import { inject } from '@angular/core';

import { CanActivateFn, Router } from '@angular/router';

import { MaintenanceService } from '../service/maintenance.service';

export const maintenanceGuard: CanActivateFn = () => {
  const maintenanceService = inject(MaintenanceService);
  const router = inject(Router);
  if (!maintenanceService.isActive || maintenanceService.isBypassed) {
    return true;
  }
  return router.parseUrl(maintenanceService.maintenanceRoute);
};
